// extracted by mini-css-extract-plugin
export default {"clipboardModeIcon":"fAId5EmTant4j5CdI-IcHw==","clipboardModeContent":"_74MsCNdo-xHxarnXhwTsjA=="};